"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = __importDefault(require("gsap"));
const Util_1 = __importDefault(require("../../Util"));
const vs = `
  varying vec2 v_uv;
  void main() {
    v_uv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
const fs = `
  precision mediump float;
  varying vec2 v_uv;
  uniform float u_time;
  uniform vec4 u_metaballs[20];

  void main() {
    vec2 st = 2.0 * v_uv - 1.0;
    float v = 0.0;
    for ( int i = 0; i < 20; i++ ) {
      vec4 mb = u_metaballs[i];
      float dx = st.x + cos(u_time + mb.w) * mb.x;
      float dy = st.y + sin(u_time + mb.w) * mb.y;
      float r = mb.z;
      v += r * r / (dx * dx + dy * dy);
    }
    vec4 color = vec4(1.0);
    float rangeMax = 5.2;
    float rangeMin = 4.7;
    if (v > rangeMax) {
      color = vec4(0.0, 0.0, 0.0, 1.0);
    } else if (v > rangeMin) {
      color = vec4(0.0, 0.0, 0.0, smoothstep(1.0, 0.0, (rangeMax - v) / (rangeMax - rangeMin)));
    } else {
      color = vec4(1.0, 1.0, 1.0, 0.0);
    }

    gl_FragColor = color;

  }
`;
class ConcernCircle extends THREE.Object3D {
    constructor(width = 1, height = 1) {
        super();
        this.width = width;
        this.height = height;
        this.shape = null;
        this.wireframe = null;
        this.balls = [];
        this.uniforms = {
            u_time: { value: 0.0 },
            u_metaballs: { type: 'v4', value: this.balls },
        };
        this._createShape();
    }
    update() {
        this.uniforms.u_time.value += 0.02;
    }
    pitpat() {
        this.balls.forEach(ball => {
            gsap_1.default.to(ball, {
                duration: 3,
                x: Util_1.default.random(-0.04, 0.04),
                y: Util_1.default.random(-0.04, 0.04),
                z: Util_1.default.random(0.01, 0.03),
                w: Util_1.default.random(0, 4),
            });
        });
        this.shape &&
            gsap_1.default.to(this.shape.scale, {
                duration: 1,
                x: 1,
                y: 1,
                ease: 'power2.inOut',
            });
    }
    pitpatBig() {
        this.balls.forEach(ball => {
            gsap_1.default.killTweensOf(ball);
            gsap_1.default.to(ball, {
                delay: Util_1.default.random(0, 0.5),
                duration: 3,
                x: Util_1.default.random(-0.3, 0.3),
                y: Util_1.default.random(-0.3, 0.3),
                z: Util_1.default.random(0.04, 0.13),
                w: ball.x + Util_1.default.random(1, 3),
                ease: 'power1.inOut',
            });
        });
    }
    pitpatBigMore() {
        this.balls.forEach(ball => {
            gsap_1.default.killTweensOf(ball);
            gsap_1.default.to(ball, {
                delay: Util_1.default.random(0, 0.5),
                duration: 3,
                x: Util_1.default.random(-0.5, 0.5),
                y: Util_1.default.random(-0.5, 0.5),
                z: Util_1.default.random(0.04, 0.3),
                w: ball.x + Util_1.default.random(4, 15),
                ease: 'power2.inOut',
            });
        });
    }
    scatter(cb) {
        this.balls.forEach(ball => {
            gsap_1.default.killTweensOf(ball);
            gsap_1.default.to(ball, {
                delay: Util_1.default.random(0, 1),
                duration: 2,
                x: Util_1.default.random(ball.x - 0.3, ball.x + 0.3),
                y: Util_1.default.random(ball.y - 0.3, ball.y + 0.3),
                z: 0,
                w: Util_1.default.random(0.8, 2),
                ease: 'power1.out',
            });
        });
        gsap_1.default.delayedCall(3.05, () => cb());
    }
    _createShape() {
        this._createMetaballs();
        const geo = new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1);
        const mat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.shape.scale.set(0.2, 0.2, 1);
        this.add(this.shape);
    }
    _createMetaballs() {
        for (let i = 0; i < 20; i++) {
            this.balls.push(new THREE.Vector4());
        }
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
}
exports.default = ConcernCircle;
